// // theme.ts
// import { createTheme, PaletteOptions } from '@mui/material/styles';

// // Define a custom palette interface that extends PaletteOptions
// interface CustomPaletteOptions extends PaletteOptions {
//   brand: {
//     main: string;
//     dark: string;
//     light: string;
//     contrastText: string;
//   };
// }

// // Create the theme using createTheme function
// const theme = createTheme({
//   palette: {
//     grey: {
//       50: '#FAFAFA',
//       100: '#F5F5F5',
//       200: '#EEEEEE',
//       300: '#E0E0E0',
//       400: '#BDBDBD',
//       500: '#9E9E9E',
//       600: '#757575',
//       700: '#616161',
//       800: '#424242',
//       900: '#212121',
//     },
//     // Define the brand colors in the palette
//     brand: {
//       main: '#1A237E', // Your brand color
//       dark: '#0056b3', // Darker shade of brand color
//       light: '#6a7bb0', // Lighter shade of brand color
//       contrastText: '#FFFFFF', // Text color that contrasts with brand color
//     },
//   } as CustomPaletteOptions, // Cast to CustomPaletteOptions
//   typography: {
//     fontFamily: 'Ubuntu',
//     h1: {
//       fontSize: '2rem',
//       fontWeight: 500,
//     },
//     // Add more typography styles as needed
//   },
// });

// export default theme;

// const brand = {
//   900: '#00274c',
//   800: '#013864',
//   700: '#064170',
//   600: '#134a7b',
//   500: '#1c5284',
//   400: '#466a93',
//   300: '#6884a4',
//   200: '#92a6be',
//   100: '#bcc9d8',
//   50: '#e5e9ef',
// };

export const primary = {
  900: '#0d0d0d',
  800: '#2e2e2e',
  700: '#4b4b4b',
  600: '#5e5e5e',
  500: '#858585',
  400: '#a6a6a6',
  300: '#cbcbcb',
  200: '#dfdfdf',
  100: '#ececec',
  50: '#f6f6f6',
};

// const brand = {
//   900: '#000048',
//   800: '#0b135d',
//   700: '#151c68',
//   600: '#1e2573',
//   500: '#232b7b',
//   400: '#43488d',
//   300: '#62669f',
//   200: '#8d90ba',
//   100: '#b9bbd6',
//   50: '#e3e4ee',
// };
const brand = {
  900: '#60bb32',
  800: '#60bb32',
  700: '#60bb32',
  600: '#60bb32',
  500: '#6fcc3a',
  400: '#86d45a',
  300: '#9edc7a',
  200: '#bae6a1',
  100: '#d6f0c6',
  50: '#eff9e8',
};

// export const secondary = {
//   900: '#1b1b1b',
//   800: '#3b3b3b',
//   700: '#5a5a5a',
//   600: '#6d6d6d',
//   500: '#959595',
//   400: '#b5b5b5',
//   300: '#d9d9d9',
//   200: '#e9e9e9',
//   100: '#f2f2f2',
//   50: '#f9f9f9',
// };

export const secondary = {
  900: '#3c3c3c',
  800: '#606060',
  700: '#818181',
  600: '#979797',
  500: '#c2c2c2',
  400: '#dedede',
  300: '#f0f0f0',
  200: '#f5f5f5',
  100: '#fafafa',
  50: '#ffffff',
};

export const accent = {
  900: '#ffffff',
  800: '#ffffff',
  700: '#ffffff',
  600: '#ffffff',
  500: '#ffffff',
  400: '#ffffff',
  300: '#ffffff',
  200: '#ffffff',
  100: '#ffffff',
  50: '#ffffff',
};

// export const accent = {
//   900: '#f5712e',
//   800: '#f88e34',
//   700: '#f99e37',
//   600: '#fcb03a',
//   500: '#fdbd3e',
//   400: '#fec64e',
//   300: '#ffd166',
//   200: '#ffdd8f',
//   100: '#ffeaba',
//   50: '#fff7e4',
// };

// export const complementary = {
//   900: '#3e1700',
//   800: '#4c2500',
//   700: '#593209',
//   600: '#673e12',
//   500: '#714717',
//   400: '#8b6035',
//   300: '#a47b52',
//   200: '#c69e7a',
//   100: '#e7c3a1',
//   50: '#ffe6c4',
// };

export const complementary = {
  900: '#484800',
  800: '#6d660d',
  700: '#837815',
  600: '#99891f',
  500: '#aa9727',
  400: '#b7a547',
  300: '#c4b367',
  200: '#d6c891',
  100: '#e7debb',
  50: '#f6f2e4',
};

export default brand;

